import { render, staticRenderFns } from "./SalesPointUpload.vue?vue&type=template&id=be46e404&scoped=true&"
import script from "./SalesPointUpload.vue?vue&type=script&lang=js&"
export * from "./SalesPointUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be46e404",
  null
  
)

export default component.exports